import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function MayaMallProgramCIP({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    setPrimaryDetails(prev => ({
      ...prev,
      [name]: value
    }));
    
    if (isError[name]) {
      setIsError(prev => ({
        ...prev,
        [name]: false
      }));
    }
  };

  const validateForm = () => {
    const errors = {};

    if (!primaryDetails.cip_task) {
      errors.cip_task = true;
    }

    if (primaryDetails.cip_task === "CIP Monitoring Visit" && !primaryDetails.cip_status) {
      errors.cip_status = true;
    }

    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = () => {
    if (validateForm()) {
      if (primaryDetails.cip_task === "Not Applicable") {
        navigation.go("point-of-contact");
      }
      else if (primaryDetails.cip_task === "CIP Rollout or Take-up") {
        navigation.go("maya-mall-program-section-70");
      }
      else if (primaryDetails.cip_task === "CIP Monitoring Visit" && primaryDetails.cip_status === "Not Joined CIP") {
        navigation.go("maya-mall-program-section-70");
      }
      else if (primaryDetails.cip_task === "CIP Monitoring Visit" && primaryDetails.cip_status === "Joined CIP") {
        navigation.go("point-of-contact");
      }
    } else {
      if (!primaryDetails.cip_task) {
        toast.error("Please select a CIP Task option.");
      } else if (primaryDetails.cip_task === "CIP Monitoring Visit" && !primaryDetails.cip_status) {
        toast.error("Please select the CIP Status - Joined or Not Joined.");
      }
    }
  };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">
                MAYA MALL PROGRAM IMPLEMENTATION (CIP)
              </h4>
              <p className="form-desc">
                Please provide Maya Mall Program Implementation details
              </p>
            </div>
            
            <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">
                  {/* CIP Task Section */}
                  <Form.Group className="mb-5">
                    <Form.Label className="form-label">
                      Choose CIP Task 
                      <span className="form-required">*</span>
                    </Form.Label>
                    
                    <div className={`form-radio-group ${isError.cip_task ? 'form-group-error' : ''}`}>
                      <div className="form-radio-item">
                        <Form.Check
                          type="radio"
                          id="cip_rollout"
                          name="cip_task"
                          value="CIP Rollout or Take-up"
                          checked={primaryDetails.cip_task === "CIP Rollout or Take-up"}
                          onChange={handleInputChange}
                          label="CIP Rollout or Take-up"
                          className="form-radio"
                        />
                      </div>

                      <div className="form-radio-item">
                        <Form.Check
                          type="radio"
                          id="cip_monitoring"
                          name="cip_task"
                          value="CIP Monitoring Visit"
                          checked={primaryDetails.cip_task === "CIP Monitoring Visit"}
                          onChange={handleInputChange}
                          label="CIP Monitoring Visit"
                          className="form-radio"
                        />
                      </div>

                      <div className="form-radio-item">
                        <Form.Check
                          type="radio"
                          id="cip_not_applicable"
                          name="cip_task"
                          value="Not Applicable"
                          checked={primaryDetails.cip_task === "Not Applicable"}
                          onChange={handleInputChange}
                          label="Not Applicable"
                          className="form-radio"
                        />
                      </div>
                    </div>
                    
                    {isError.cip_task && (
                      <div className="form-error">
                        Please select a CIP Task option.
                      </div>
                    )}
                  </Form.Group>

                

                  {/* Conditional CIP Status Section */}
                  {primaryDetails.cip_task === "CIP Monitoring Visit" && (
                    <Form.Group className="mb-5">
                      <Form.Label className="form-label">
                        CIP Status - Joined or Not Joined
                        <span className="form-required">*</span>
                      </Form.Label>

                      <div className={`form-radio-group ${isError.cip_status ? 'form-group-error' : ''}`}>
                        {[
                          { id: "status_joined", value: "Joined CIP", label: "Joined CIP" },
                          { id: "status_not_joined", value: "Not Joined CIP", label: "Not Joined CIP" }
                        ].map((option) => (
                          <div key={option.id} className="form-radio-item">
                            <Form.Check
                              type="radio"
                              id={option.id}
                              name="cip_status"
                              value={option.value}
                              checked={primaryDetails.cip_status === option.value}
                              onChange={handleInputChange}
                              label={option.label}
                              className="form-radio"
                            />
                          </div>
                        ))}
                      </div>

                      {isError.cip_status && (
                        <div className="form-error">
                          Please select the CIP Status - Joined or Not Joined.
                        </div>
                      )}
                    </Form.Group>
                  )}

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                    >
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MayaMallProgramCIP;